import { render, staticRenderFns } from "./ticket-item.vue?vue&type=template&id=5020693f&"
import script from "./ticket-item.vue?vue&type=script&lang=js&"
export * from "./ticket-item.vue?vue&type=script&lang=js&"
import style0 from "./ticket-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports